import request from "@/utils/request";



export function sendSms(data) {
  return request({
    url: '/interface/sms/sendAliMsg',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/sms.js